import { track } from "@/lib/customer-intelligence/tracker";
import { getSession } from "@/lib/customer-intelligence/session";
import { shouldLoadGtm } from "@/lib/analytics/gtm";
import { allowAnalytics } from "@/lib/consent/enforcement";

/**
 * Reuse the existing first-party event queue. This is evidence of a browser
 * action, never evidence of an ad-platform acknowledgement or payment.
 * The report validates purchases against orders.meta_event_id.
 */
export function recordCommerceEvidence(payload: Record<string, unknown>): void {
  try {
    if (typeof window === "undefined" || !shouldLoadGtm(window.location.hostname, window.location.pathname)) return;
    if (!allowAnalytics()) return;
    const name = String(payload.event ?? "");
    if (!["view_item", "add_to_cart", "begin_checkout", "purchase"].includes(name)) return;
    const eventId = typeof payload.event_id === "string" ? payload.event_id : "";
    if (eventId.length < 8 || eventId.length > 64) return;
    const commerce = payload.ecommerce as Record<string, unknown> | undefined;
    const session = getSession();
    // Allowlist only. No products, quiz answers, email, phone, or full URLs.
    track(name, {
      evidence_version: 1,
      canonical_event_id: eventId,
      ...(name === "purchase" ? { transaction_id: commerce?.transaction_id } : {}),
      source_session_id: session.sessionId,
      marketing_consent: window.localStorage.getItem("truwe_marketing_consent") === "granted"
        ? "granted" : window.localStorage.getItem("truwe_marketing_consent") === "denied" ? "denied" : "unknown",
    }, eventId);
  } catch {
    // Analytics must never interrupt checkout or the original GTM push.
  }
}
